export const LOGIN_MESSAGES = {
  TITLE: 'Login',
  ERROR_DESCRIPTION: 'Login failed!',
  SUCCESS_DESCRIPTION: 'Login successful!',
}